import { Routes, RouterModule } from '@angular/router';

import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';
import { AuthGuard } from './_guards/auth.guard';
import { ActivateComponent } from './activate/activate.component';
import { AppComponent } from './app.component';

const appRoutes: Routes = [
    { path: '', redirectTo: 'home', pathMatch: 'full' },
    { path: 'login', component: LoginComponent },
    { path: 'activate', component: ActivateComponent },
    { path: 'home', component: HomeComponent, canActivate: [AuthGuard] },
    { path: 'invoice', loadChildren: './invoice/invoice.module#InvoiceModule', canActivate: [AuthGuard] },
    { path: 'item', loadChildren: './item/item.module#ItemModule', canActivate: [AuthGuard] },
    { path: 'settings', loadChildren: './settings/settings.module#SettingsModule', canActivate: [AuthGuard] },
    { path: 'report', loadChildren: './report/report.module#ReportModule', canActivate: [AuthGuard] },
    // otherwise redirect to home
    { path: '**', redirectTo: '' }
];

export const routing = RouterModule.forRoot(appRoutes);
